module.exports = __webpack_public_path__ + "shanz/static/media/impression_banner5.d2f1ff00.png";